import React, { Component } from 'react';
import {ref} from '../config/firebase';
import Nav from './components/Nav';
import Footer from './components/Footer';
import {Tabs, Tab} from 'react-bootstrap';

import Error from '../helpers/Error';

export default class Awards extends Component {
    constructor(props) {
        super(props);
        this.state = {
            aKey: 1,
            items: [],
            edit: false,
            err: null,
            status: null,
            key: '',
            year: ''
        };
        this.dbItems = ref.child('awards');
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
    }


    componentDidMount() {
        this.dbItems.on('value', dataSnapshot => {
            var items = [];

            dataSnapshot.forEach(function(childSnapshot) {

                dataSnapshot.child(childSnapshot.key).forEach(function(snapshot) {
                    var item = snapshot.val();

                    item['.year'] = childSnapshot.key;
                    item['.key'] = snapshot.key;

                    items.push(item);
                });

            });

            this.setState({items:items});
        });


    }

    componentWillUnmount() {
        this.dbItems.off();
    }

    handleSubmit(e) {
        e.preventDefault();

        if( (this.year.value !== "" || this.year_new.value !== '') &&
            this.name.value !== "" &&
            this.description.value !== "" ) {

            if(this.state.edit) { // edit
                this.dbItems.child(this.state.year + '/'+ this.state.key).update({
                    name: this.name.value,
                    description: this.description.value
                });
                this.setState({
                    err: "Success Edit Awards!",
                    status: null,
                    edit: false,
                    key: '',
                    year: ''
                });
                this.handleSelect(1);
            }
            else { // create
                this.dbItems.child(this.year.value).push({
                    name: this.name.value,
                    description: this.description.value
                })

                this.setState({err: "Success Insert New Awards!", status: null});
            }

            // empth value
            this.year.value = '';
            this.name.value = '';
            this.description.value = '';

        }
        else {
            this.setState({err: "Something Wrong", status:'err'});
        }

    }

    removeItem(year, key) {
        this.dbItems.child(year + '/' + key).remove();
    }

    editItem(year, key) {
        this.dbItems.child(year + '/' + key).once('value', dataSnapshot => {

            var data = dataSnapshot.val();

            // set back value
            this.year_new.value = year;
            this.name.value = data.name;
            this.description.value = data.description;

            this.handleSelect(2);

            this.setState({
                edit:true,
                year: year,
                key: key
            });
        });


    }

    handleSelect(aKey) {
        this.setState({aKey});
    }

    render () {
        var dat = [ 'Awards List', 'Create Awards' ];
        var i = 0;
        var currYear = (new Date()).getFullYear();
        var _this = this;

        var selectYear = [];

        for(var j = currYear ; j >= 2013 ; j--) {
            selectYear.push(<option key={Math.random()} value={j}>{j}</option>);
        }

        return (
            <div>
                <Nav />
                <div className="container">
                    <div className="row">
                        <h1>AWARDS</h1>
                        <Error err={this.state.err} status={this.state.status}/>
                        <Tabs activeKey={this.state.aKey} onSelect={this.handleSelect} id="awardTab">
                            <Tab eventKey={1} title={dat[0]}>
                                <h3>{dat[0]}</h3>
                                <table className="table table-bordered">
                                    <thead>
                                    <tr>
                                        <th>No</th>
                                        <th>Year</th>
                                        <th>Award Name</th>
                                        <th>Award Description</th>
                                        <th>Action</th>
                                    </tr>
                                    </thead>

                                    <tbody>
                                    {
                                        this.state.items.map(function(item) {
                                            return (
                                                <tr key={item['.key']}>
                                                    <td>{++i}.</td>
                                                    <td>{item['.year']}</td>
                                                    <td>{item.name}</td>
                                                    <td>{item.description}</td>

                                                    <td>
                                                        <a data-toggle="tab" className="btn btn-info" onClick={()=>{_this.editItem(item['.year'], item['.key'])}}>Edit</a> &nbsp;
                                                        <a className="btn btn-danger" onClick={() => { _this.removeItem(item['.year'], item['.key']) }}>Delete</a>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    }

                                    </tbody>
                                </table>
                            </Tab>

                            <Tab eventKey={2} title={(this.state.edit)? 'Edit Awards' : dat[1]}>
                                <h3>{(this.state.edit)? 'Edit Awards' : dat[1]}</h3>
                                <form onSubmit={this.handleSubmit}>
                                    <div className="form-group">
                                        <label>Year</label>
                                        <input type="text" disabled="disabled" className={"form-control "+(this.state.year === ''? 'hidden' : '')} ref={(year_new)=>this.year_new=year_new}/>
                                        <select ref={(year)=>this.year=year} className={"form-control " + (this.state.year === ''? '' : 'hidden')}>
                                            <option value="">-Select year-</option>
                                            {selectYear}
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label>Award Name</label>
                                        <input type="text" ref={(name) => this.name = name} className="form-control" placeholder="Ex: Graduated In Computer Science"/>
                                    </div>
                                    <div className="form-group">
                                        <label>Award Description</label>
                                        <textarea ref={(description) => this.description = description} className="form-control" placeholder="Ex: Graduated in Computer Science with Predicate Magna Cum Laude."></textarea>

                                    </div>

                                    <button type="submit" className="btn btn-default">{(this.state.edit)?'Edit':'Create'}</button> &nbsp;
                                    <button type="reset" className="btn btn-warning">Cancel</button>
                                </form>
                            </Tab>
                        </Tabs>

                    </div>
                </div>
                <Footer/>
            </div>

        )
    }
}


// WEBPACK FOOTER //
// ./src/auth_pages/Awards.js